import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Modal, Loader } from "arv-reactcomponents";
import { RefineView, SortByView } from "../FilterViews";
import ApplyCancelButton from "../ApplyCancelButton";

@withRouter
@inject("ProductStore")
@observer
class MobileFilterContainer extends Component {
  constructor() {
    super();
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    const { pathname, search } = this.props.location;
    this.props.ProductStore.storeTempUrl(pathname, search);
    this.props.ProductStore.clearTempFilters();
    this.props.ProductStore.toggleMobileFilters(
      this.props.ProductStore.mobileFilterToggle.activeFilter,
    );
  }
  render() {
    const { isFetchingData } = this.props.ProductStore;
    return (
      <Fragment>
        <Modal
          isOpen={this.props.ProductStore.mobileFilterToggle.refine}
          onClose={this.closeModal}
          className="nw-mobilefilters"
        >
          {isFetchingData && (
            <div className="nw-mobilefilters-loader">
              <div className="nw-mobilefilters-loaderholder">
                <Loader />
              </div>
            </div>
          )}

          <RefineView.component />
          <ApplyCancelButton.component />
        </Modal>
        <Modal
          isOpen={this.props.ProductStore.mobileFilterToggle.sortBy}
          onClose={this.closeModal}
          className="nw-mobilefilters"
        >
          <SortByView.component />
        </Modal>
      </Fragment>
    );
  }
}
MobileFilterContainer.wrappedComponent.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({
    isFetchingData: PropTypes.bool.isRequired,
    clearTempFilters: PropTypes.func.isRequired,
    storeTempUrl: PropTypes.func.isRequired,
    toggleMobileFilters: PropTypes.func.isRequired,
    mobileFilterToggle: PropTypes.shape({
      refine: PropTypes.bool.isRequired,
      sortBy: PropTypes.bool.isRequired,
      activeFilter: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ProductStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: MobileFilterContainer.wrappedComponent,
  component: MobileFilterContainer,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MobileFilters/MobileFilterContainer/index.js